import { Button, Card, Form } from "react-bootstrap";
import { useState } from "react";
import Layout from "../components/Layout";

export default function Home() {
    const [qrID, setQRID] = useState("");

    function cekValiditas() {
        window.location.href = "/" + qrID;
    }
    return (
        <Layout>
            <Card className="text-center mx-auto glass-effect" style={{ maxWidth: "40rem" }}>
                <Card.Header>VALID SIASN</Card.Header>
                <Card.Body>
                    <Card.Title>Cek Validitas Tanda Tangan Digital</Card.Title>
                    <Card.Text>
                        Masukkan QR-ID untuk mengecek validitas tanda tangan digital.
                    </Card.Text>
                    <Form.Control
                        type="text"
                        className="text-center mt-4"
                        placeholder="QR-ID"
                        value={qrID}
                        onChange={(e) => setQRID(e.target.value)}
                    />
                </Card.Body>
                <Card.Footer className="text-muted">
                    <Button variant="primary" style={{ opacity: "0.9" }} onClick={cekValiditas}>
                        Cek Validitas
                    </Button>
                </Card.Footer>
            </Card>
        </Layout>
    );
}
